<nz-card>
  <div class="toolbar">
    <h1>{{ 'ADMIN.EMAIL_CAMPAIGNS.TITLE' | translate }}</h1>
    <button nz-button nzType="primary" (click)="createNew()">{{ 'ADMIN.EMAIL_CAMPAIGNS.CREATE' | translate }}</button>
  </div>

  <div class="filters">
    <input nz-input [(ngModel)]="search" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.SEARCH' | translate" (ngModelChange)="load()" />
    <nz-select [(ngModel)]="statusFilter" (ngModelChange)="load()" [nzAllowClear]="true" [nzPlaceHolder]="'ADMIN.EMAIL_CAMPAIGNS.STATUS' | translate">
      <nz-option nzValue="draft" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.DRAFT' | translate"></nz-option>
      <nz-option nzValue="ready" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.READY' | translate"></nz-option>
      <nz-option nzValue="sending" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.SENDING' | translate"></nz-option>
      <nz-option nzValue="sent" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.SENT' | translate"></nz-option>
      <nz-option nzValue="failed" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.FAILED' | translate"></nz-option>
      <nz-option nzValue="archived" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.ARCHIVED' | translate"></nz-option>
    </nz-select>
  </div>

  <nz-table [nzData]="campaigns" [nzLoading]="loading" [nzPageSize]="10">
    <thead>
      <tr>
        <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.NAME' | translate }}</th>
        <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.SUBJECT' | translate }}</th>
        <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.STATUS' | translate }}</th>
        <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.UPDATED_AT' | translate }}</th>
        <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.ACTIONS' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of campaigns">
        <td>{{ item.name }}</td>
        <td>{{ item.subject }}</td>
        <td>
          <nz-tag [nzColor]="statusColor(item.status)">{{ ('ADMIN.EMAIL_CAMPAIGNS.STATUS_VALUES.' + (item.status || '').toUpperCase()) | translate }}</nz-tag>
        </td>
        <td>{{ item.updatedAt | date: 'short' }}</td>
        <td>
          <button nz-button nzType="link" (click)="edit(item)">{{ 'COMMON.EDIT' | translate }}</button>
          <button nz-button nzType="link" (click)="openHistory(item)">{{ 'ADMIN.EMAIL_CAMPAIGNS.SEND_HISTORY' | translate }}</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

